import createDateAsUTC from '../utility/createDateAsUTC'
import convertDateToUTC from '../utility/convertDateToUTC'

export const convertDatetimeToEpochtime = datetime => {
  const epoch = new Date(datetime).getTime()
  // const epoch = createDateAsUTC(new Date(datetime)).getTime()
  //const epoch = convertDateToUTC(new Date(datetime)).getTime()

  return epoch
}

const convertDatetimesToEpochtimes = datetimes => {
  const epochtimes = datetimes.map(datetime =>
    convertDatetimeToEpochtime(datetime)
  )

  return epochtimes
}

export default convertDatetimesToEpochtimes



// WEBPACK FOOTER //
// ./src/utility/convertDatetimesToEpochtimes.js